import { render, staticRenderFns } from "./DelCache.vue?vue&type=template&id=5d08181a&scoped=true&"
import script from "./DelCache.vue?vue&type=script&lang=js&"
export * from "./DelCache.vue?vue&type=script&lang=js&"
import style0 from "./DelCache.vue?vue&type=style&index=0&id=5d08181a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d08181a",
  null
  
)

export default component.exports